import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
import "./App.css";
import logoECJ from "./img/ecj-logo.svg";

const SVANT_PALETTE = [
  "#235B67",
  "#227E79",
  "#23A487",
  "#23C998",
  "#70D460",
  "#A3C854",
];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (<text
    x={x}
    y={y}
    fill="white"
    textAnchor="middle"
    dominantBaseline="central"
    fontSize={12}
  >
    {`${(percent * 100).toFixed(0)}%`} </text>
  );
};

const PieChartWithCustomizedLabel = ({ title, data }) => (

  <div className="chartCard">
    <h3 style={{ marginBottom: 8 }}>{title}</h3>
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={data || []}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius={90}
          dataKey="value"
          nameKey="label"
        >
          {(data || []).map((_, idx) => (
            <Cell key={idx} fill={SVANT_PALETTE[idx % SVANT_PALETTE.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  </div>
);

export default function Visualizar() {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000';
  const handlePrint = () => { window.print(); };
  const [codes, setCodes] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [ecj, setEcj] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/dashboard-tables`)
      .then((res) => res.json())
      .then((response) => {
        setCodes(response.codes || []);
        setUserDetails(response.user_details || []);
      })
      .catch((error) => {
        console.error("Error al obtener tablas del dashboard:", error);
      });

    fetch(`${BACKEND_URL}/ecj-stats`)
      .then(res => res.json())
      .then(setEcj)
      .catch(err => console.error("Error al obtener ECJ stats:", err));
  }, [BACKEND_URL]);

  return (
    <div className='container'>
      <div className='containerFlex'>
        <div className='card flexBetween printHeader'>
          <img
            className='logoECJ'
            src={logoECJ}
            alt="Econo Journal"
          />

          <div>
            <button className='btnPrint' onClick={handlePrint}>
              Imprimir
            </button>
          </div>

        </div>
      </div>

      {ecj && (
        <div className='containerFlex'>
          <div className='card-2'>
            <PieChartWithCustomizedLabel
              title="Probabilidad reformas eléctricas (MAT & recontract.)"
              data={ecj.reforms_probability}
            />
          </div>

          <div className='card-2'>
            <PieChartWithCustomizedLabel
              title="Segmento prioritario"
              data={ecj.priority_segment}
            />
          </div>

          <div className='card-2'>
            <PieChartWithCustomizedLabel
              title="Energías renovables próximos 5 años"
              data={ecj.renewables_outlook}
            />
          </div>

          <div className='card-2'>
            <PieChartWithCustomizedLabel
              title="Financiamiento competitivo para proyectos de energías renovables"
              data={ecj.competitive_finance}
            />
          </div>

        </div>
      )}

      <div className='card'>
        <h2>Códigos de invitación</h2>
        <div className='cont2Col'>
          <table className='table2Col'>
            <thead>
              <tr>
                <th>ID</th>
                <th>Código</th>
                <th>Activo</th>
                <th>Usos</th>
                <th>Límite</th>
              </tr>
            </thead>
            <tbody>
              {codes.slice(0, 25).map(code => (
                <tr key={code.id_invitation_code}
                  style={{
                    backgroundColor:
                      code.usage_limit !== null && code.usage_count >= code.usage_limit
                        ? '#ffd6d6'
                        : 'transparent'
                  }}>
                  <td>{code.id_invitation_code}</td>
                  <td>{code.code}</td>
                  <td>{code.is_active ? 'Sí' : 'No'}</td>
                  <td>{code.usage_count}</td>
                  <td>{code.usage_limit}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <table className='table2Col'>
            <thead>
              <tr>
                <th>ID</th>
                <th>Código</th>
                <th>Activo</th>
                <th>Usos</th>
                <th>Límite</th>
              </tr>
            </thead>
            <tbody>
              {codes.slice(25).map(code => (
                <tr key={code.id_invitation_code}
                  style={{
                    backgroundColor:
                      code.usage_limit !== null && code.usage_count >= code.usage_limit
                        ? '#ffd6d6'
                        : 'transparent'
                  }}>
                  <td>{code.id_invitation_code}</td>
                  <td>{code.code}</td>
                  <td>{code.is_active ? 'Sí' : 'No'}</td>
                  <td>{code.usage_count}</td>
                  <td>{code.usage_limit}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className='card'>
        <h2>Detalles completos de inscriptos</h2>
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Email</th>
              <th>DNI</th>
              <th>Teléfono</th>
              <th>Empresa</th>
              <th>Código</th>
              <th>Estado de pago</th>
            </tr>
          </thead>
          <tbody>
            {userDetails.map(user => (
              <tr key={user.id_user_response}>
                <td>{user.first_name}</td>
                <td>{user.last_name}</td>
                <td>{user.email}</td>
                <td>{user.dni}</td>
                <td>{user.phone}</td>
                <td>{user.company || '-'}</td>
                <td>{user.invitation_code || '-'}</td>
                <td>{user.payment_status || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <h4 className='printTitle'>Reporte generado por Svant para</h4><h4 className='printTitle'><b id='eventName'>EconoJournal</b></h4>
    </div>
  );
}
